<template>
  <div class="main-container">
    <div class="main-left">
      <el-menu
        :default-active="defaultActive"
        unique-opened
        class="el-menu-vertical-demo"
        @select="handleSelect"
      >
        <el-menu-item index="1">
          <span slot="title">底图设置</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultActive: "1",
    };
  },
  methods: {
    handleSelect(index) {
      if (index == 1) {
        this.$router.push({ path: "/setting/baseMapSetting" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  .main-left {
    min-width: 240px;
    height: 45px;
  }
  .main-right {
    width: calc(100vw - 290px);
    overflow-y: hidden;
    overflow-x: auto;
  }
}
</style>